import { useEffect, useState } from "react";
import { SelectInput } from "nystem-components";
import app from "nystem";

const FloatRefund = ({ model, view, setValue }) => {
  const [products, setProducts] = useState();
  const [product, setProduct] = useState();
  const [months, setMonths] = useState();
  const [isYearly, setIsYearly] = useState();
  const [refundedPrice] = useState(
    view.getValue("refundDate")
      ? Number(view.getValue("refundPrice")) || 0
      : 0,
  );
  const [refundedSums] = useState(
    view.getValue("refundDate")
      ? view.getValue("refundSums") || []
      : [],
  );

  const setRefund = async (refundPrice, product) => {
    const index = view.getValue("product").indexOf(product);
    const price = product
      ? Number(view.getValue("productPrices")?.[index]) ||
        Number(view.getValue("price")) ||
        0
      : Number(view.getValue("price")) || 0;
    const refundedSum = product
      ? refundedSums.length
        ? Number(refundedSums[index]) || 0
        : (refundedPrice / (Number(view.getValue("price")) || 1)) * price
      : refundedPrice;
    refundPrice = Math.min(refundPrice, Math.max(price - refundedSum, 0));
    await setValue(refundPrice);
    await view.setValue({
      path: "refundSums",
      value:
        products.length > 1 && product
          ? view
              .getValue("product")
              .map((id) => (id === product ? refundPrice : 0))
          : [],
    });
  };

  useEffect(() => {
    let mounted = true;

    (async () => {
      const products = await Promise.all(
        view
          .getValue("product")
          .map((id) => app.database.product.get({ id })),
      );
      if (!mounted) return;

      setProducts(products);
      setProduct(products.length > 1 ? undefined : view.getValue("product")[0]);
    })();

    return () => {
      mounted = false;
    };
  }, [view]);

  useEffect(() => {
    if (!products) return;
    let mounted = true;

    (async () => {
      if (!product) {
        setIsYearly(false);
        setMonths(1);
        await setRefund(Number(view.getValue("price")) || 0);
        return;
      }

      const index = view.getValue("product").indexOf(product);
      const isYearly = products[index].data?.recurring === "year";
      const price =
        view.getValue("productPrices")?.[index] ?? view.getValue("price") ?? 0;
      let months = 1;

      if (isYearly) {
        const subscription = await app.database.subscription.get({
          id: view.getValue("subscription")[index],
        });
        if (!mounted) return;

        const start = new Date(Number(view.getValue("_crdate")));
        const now = new Date();
        let elapsed =
          (now.getFullYear() - start.getFullYear()) * 12 +
          now.getMonth() -
          start.getMonth();
        if (now.getDate() < start.getDate()) elapsed--;
        months =
          Number(subscription.data?.expires) <= now.getTime()
            ? 1
            : Math.max(1, Math.min(12, 12 - elapsed));
      }

      if (!mounted) return;
      setIsYearly(isYearly);
      setMonths(months);
      await setRefund(
        isYearly
          ? Math.round(((Number(price) || 0) / 12) * months * 100) / 100
          : Number(price) || 0,
        product,
      );
    })();

    return () => {
      mounted = false;
    };
    // setValue is recreated by the content type renderer on every render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [product, products, view]);

  if (!products || !months) return null;

  return (
    <>
      {products.length > 1 && (
        <SelectInput
          model={{
            text: "Product to refund",
            render: "dropdown",
            dropdownText: "All",
            limit: 1,
            option: products.map(({ data }) => ({
              _id: data._id,
              text: data.name,
            })),
          }}
          value={product}
          view={view}
          setValue={setProduct}
        />
      )}
      {isYearly && (
        <SelectInput
          model={{
            ...model,
            option: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
          }}
          value={months}
          view={view}
          setValue={async (months) => {
            const index = view.getValue("product").indexOf(product);
            setMonths(months);
            await setRefund(
              Math.round(
                ((Number(
                  view.getValue("productPrices")?.[index] ??
                    view.getValue("price"),
                ) || 0) /
                  12) *
                  months *
                  100,
              ) / 100,
              product,
            );
          }}
        />
      )}
    </>
  );
};

export default FloatRefund;
